import { Button } from 'datocms-react-ui';

type MergeLabelProps = {
  selectedMergeFieldProperty: {
    groupIndex: number;
    controlIndex: number;
    property: string;
  }[];
  onCancel: () => void;
  onMerge: () => void;
};

export function MergeLabel({
  selectedMergeFieldProperty,
  onCancel,
  onMerge,
}: MergeLabelProps) {
  return (
    <div
      style={{
        position: 'sticky',
        bottom: '16px',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'rgb(68, 127, 192)',
        padding: '16px',
        margin: '16px',
        borderRadius: '16px',
        boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
      }}
    >
      <span style={{ color: '#fff', fontWeight: 600, fontSize: '14px' }}>
        Merge {selectedMergeFieldProperty.length} selected fields (Property:{' '}
        {selectedMergeFieldProperty?.[0]?.property})
      </span>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: '16px',
        }}
      >
        <Button
          buttonSize="xxs"
          type="button"
          buttonType="muted"
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          buttonSize="xxs"
          type="button"
          buttonType="primary"
          disabled={selectedMergeFieldProperty.length === 1}
          onClick={onMerge}
        >
          Merge
        </Button>
      </div>
    </div>
  );
}
